import Callout from '@passkeys/ui/callout';
import React from 'react';
import { useSelector } from 'react-redux';

import exodus from '@/ui/exodus';
import selectors from '@/ui/flux/selectors';
import useBackupStatus from '@/ui/hooks/use-backup-status';
import InstallCallout from './install-callout.js';

const BACKUP_ACTION = {
  label: 'Create Backup',
  onClick: () => exodus.pairing.start(),
};

function BackupCallout() {
  return (
    <Callout type="warning" action={BACKUP_ACTION}>
      Your Passkey needs a backup.
    </Callout>
  );
}

function Callouts() {
  const { loading, backedUp } = useBackupStatus();
  const showBackupCallout = !loading && !backedUp;
  const showInstallCallout = useSelector(selectors.pwa.installCalloutVisible);

  const callouts = [
    showBackupCallout && <BackupCallout />,
    showInstallCallout && <InstallCallout />,
  ];

  return callouts.find(Boolean);
}

export default Callouts;
